import { CardContent } from '@mui/material'
import { UserTable, UserTableFilter } from '@components/user'
import { useRouteQuery } from '@hooks/useRouteQuery'
import { BoxPage } from '@/components/common'
import { Card } from '@/@core/components/mui/Card'
import { useQuery } from '@tanstack/react-query'
import { ActivityLogTypeEnum, IUser, User, UserTypeEnum } from '@/@data'
import { CreateLiftUserDrawer } from '@/components/user/lift/CreateLiftUserDrawer'
import AppLogs from '@/components/common/AppLogs'

const LiftUser = () => {
  const { searchQuery, updateQuery } = useRouteQuery()
  const { __ } = useTranslator()
  const { serializeQuery } = useRouteQuery()
  const [isOpenCreateInternalUserDrawer, setIsOpenCreateInternalUserDrawer] = useState(false)
  // const [isOpenUserLogDrawer, setIsOpenUserLogDrawer] = useState(false)
  const [isOpenLog, setIsOpenLog] = useState(false)
  const keywords = searchQuery.get('keywords')

  // Tạo params cho API
  const searchParams = useMemo(
    () => ({
      ...serializeQuery({
        page: searchQuery.get('page'),
        per_page: searchQuery.get('per_page'),
        keywords: searchQuery.get('keywords'),
        company_id: searchQuery.get('company_id'),
        created_from: searchQuery.get('created_from'),
        created_to: searchQuery.get('created_to'),
        status: searchQuery.get('status'),
        user_type: UserTypeEnum.Admin,
        role_id: searchQuery.get('role_id'),
        perPage: searchQuery.get('perPage')
      })
    }),
    [searchQuery]
  )

  useEffect(() => {
    if (keywords) {
      updateQuery({ page: undefined })
    }
  }, [keywords])

  // Fetch data từ API
  const { refetch, data: users } = useQuery({
    ...User.objects.paginateQueryFactory(searchParams)
  })

  // Mutation để update status
  const handleSearch = (value: string) => {
    // Update URL
    updateQuery({
      search: value || undefined,
      page: 1
    })
  }

  const handleAddEmployee = () => {
    setIsOpenCreateInternalUserDrawer(true)
  }

  const handleOpenLog = () => {
    setIsOpenLog(true)
  }

  // const handleHistory = () => {
  //   setIsOpenUserLogDrawer(true)
  // }

  const handleEdit = (employee: IUser) => {
    console.log('Edit employee:', employee)
  }

  return (
    <BoxPage
      title={__('Lift User Management')}
      breadcrumbs={[{ label: __('Users Management'), href: '/cms/users/employee' }, { label: __('Lift User Management') }]}
    >
      <Card
        sx={{
          borderRadius: 3
        }}
      >
        <CardContent sx={{ padding: 0 }}>
          <UserTableFilter onSearch={handleSearch} onAddEmployee={handleAddEmployee} onOpenLogs={handleOpenLog} />

          <UserTable data={users?.data || []} onEdit={handleEdit} meta={users?.meta} refetch={refetch} />
        </CardContent>
      </Card>

      <CreateLiftUserDrawer
        open={isOpenCreateInternalUserDrawer}
        setOpen={setIsOpenCreateInternalUserDrawer}
        onSuccess={() => {
          refetch()
        }}
      />

      <AppLogs
        open={isOpenLog}
        setOpen={setIsOpenLog}
        title={__('History Menu Lift User')}
        object_type={ActivityLogTypeEnum.User}
      />
    </BoxPage>
  )
}

export default LiftUser
